<script>
import {IconRouter} from '@tabler/icons-vue';
import DeviceDashboardCard from '@/Widgets/Cards/DeviceDashboardCard.vue'

export default {
  name: "DevicesList",
  components: {
    IconRouter,
    DeviceDashboardCard,
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    loading: Boolean,
    totalRecords: Number,
    rows: Number,
    first: Number,
  },
  computed: {
    getTitle() {
      return this.title ?? this.$t('common.devices');
    },
    getSubtitle() {
      return this.subtitle ?? this.$t('common.total');
    }
  }
}
</script>

<template>
  <DeviceDashboardCard
      :title="getTitle"
      :subtitle="getSubtitle"
      :loading="loading"
      :pt="{
					body: {
						style: {
              'overflow-y': 'hidden',
              'padding-bottom': 0,
              }
					},
					content: {
						style: {
							'overflow-y': 'scroll',
							'border-top': 'solid 1px rgb(203,213,225)',
							'margin-top': '0.75rem',
							'margin-bottom': '-1rem',
						}
					},
					footer: {
            class: ['p-0', 'z-10'],
					}
				}"
  >
    <div class="flex flex-col flex-1 justify-stretch -mx-5 mb-10">
      <DataView :value="value">
        <template #list="slotProps">
          <div class="flex flex-col divide-y divide-surface-200">
            <div v-for="(item, index) in slotProps.items" :key="index"
                 class="flex flex-row items-center first:pt-0 py-2.5 px-3 gap-2.5">
              <slot name="item" :item="item"/>
            </div>
          </div>
        </template>
      </DataView>
    </div>

    <template #footer>
      <Paginator
          v-show="!loading"
          :pt="{
            paginatorWrapper: {
            class: ['border-t-0']
            }
          }"
          :rows="rows"
          :first="first"
          :total-records="totalRecords"
          @page="$event => $emit('page', $event)"
          template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
      />
    </template>
  </DeviceDashboardCard>

</template>

<style scoped>

</style>
